import { IDefineCommand } from 'core-ts-types';
import { AuthenticationQueryModel } from '../queries/authentication_query_model';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';
angular
  .module('data-ng-authentication')
  .factory(
    'resetMemberConfigurationCommand',
    (
      defineCommand: IDefineCommand,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore,
      ngAuthenticationQueryModel: AuthenticationQueryModel
    ) =>
      defineCommand('resetMemberConfigurationCommand', (deferred) => {
        ngMemberConfigurationDatastore.initialize();
        deferred.resolve(ngAuthenticationQueryModel);
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/reset_member_configuration_command.ts